import { createTriggerOnEnter } from "./reveal-on-enter.js";

const FOOTER_SELECTOR = ".no-footer";

export function getFooterScrollTop() {
  const footer = document.querySelector(FOOTER_SELECTOR);
  if (!(footer instanceof HTMLElement)) {
    return null;
  }
  const footerRect = footer.getBoundingClientRect();
  return (window.scrollY || window.pageYOffset) + footerRect.top;
}

export function initFooterReveal() {
  const footer = document.querySelector(FOOTER_SELECTOR);
  if (!(footer instanceof HTMLElement)) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    footer.classList.add("is-revealed");
    return;
  }

  if (footer.dataset.footerRevealBound === "1") {
    return;
  }

  const logoShells = Array.from(
    footer.querySelectorAll(".no-footer__logo-shell"),
  );
  const logoMarks = Array.from(
    footer.querySelectorAll(".no-footer__logo-shell img"),
  );
  const topCols = Array.from(
    footer.querySelectorAll(".no-footer__top-grid > *"),
  );
  const barBlocks = Array.from(
    footer.querySelectorAll(".no-footer__bar-row > *"),
  );

  footer.dataset.footerRevealBound = "1";

  createTriggerOnEnter({
    trigger: footer,
    start: "top 92%",
    onEnter: () => {
      gsap
        .timeline({
          defaults: {
            ease: "power3.out",
          },
          onComplete: () => {
            footer.classList.add("is-revealed");
            gsap.set(
              [...logoShells, ...logoMarks, ...topCols, ...barBlocks],
              {
                clearProps: "transform,opacity,visibility",
              },
            );
          },
        })
        .to(logoShells, {
          autoAlpha: 1,
          y: 0,
          duration: 0.62,
          stagger: 0.1,
        })
        .to(
          logoMarks,
          {
            y: 0,
            duration: 0.78,
            ease: "power4.out",
            stagger: 0.1,
          },
          0.08,
        )
        .to(
          topCols,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.58,
            stagger: 0.1,
          },
          "-=0.28",
        )
        .to(
          barBlocks,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.54,
            stagger: 0.08,
          },
          "-=0.2",
        );
    },
  });
}
